var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWppbusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 2500,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0.5599999999999996 0.39 69.79 72.22",
    width: 2488,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.72 4.31c17.17 0 31.1 13.92 31.1 31.1s-13.83 31.43-31.1 31.1c-6.35-.12-10.69-.58-15.42-4.09-3.61-2.69-17.87 10.19-10.82-10.9-3.01-4.78-4.8-10.27-4.87-16.11-.19-17.1 13.93-31.1 31.11-31.1z",
    fill: "#25d366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fefefe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.18 10.58C53.61 4.02 44.89.4 35.6.39 16.45.39.86 15.98.85 35.13c0 6.12 1.6 12.09 4.64 17.36l-4.93 18 18.42-4.83a34.657 34.657 0 0 0 16.6 4.23h.02c19.15 0 34.73-15.58 34.74-34.74.01-9.28-3.6-18-10.16-24.57zM23.95 51.95c.24.15.74.15 1.9.15 4.89-.01 9.11-.02 12.11-.02 14.02 0 13.65-14.76 7.1-16.6.96-1.7 5.33-4.9 2.63-11.5-2.68-6.53-14.18-5.05-22.05-5.05-2.91 0-2.48 2.16-2.46 5.5.02 5.3 0 19.64 0 25.84 0 1.25.38 1.45.77 1.68zm6.06-5.41h7.13c3.03-.01 5.73-1.42 5.66-4.44-.05-2.84-1.94-3.78-4.57-4.04-2.5.03-5.36.03-8.22.03zm0-14.16c5.28-.07 7.31.21 10.19-.51 1.98-1.12 2.84-5.29.01-6.7-1.97-.98-7.78-.65-10.2-.55zm5.59 31.64h-.02c-5.18 0-10.26-1.39-14.69-4.02l-1.06-.63L8.9 62.24l2.92-10.65-.69-1.1a28.798 28.798 0 0 1-4.41-15.36c0-15.92 12.96-28.87 28.89-28.87 7.71 0 14.96 3.01 20.41 8.47 5.46 5.45 8.46 12.71 8.46 20.42-.01 15.92-12.97 28.87-28.88 28.87z",
    stroke: "#25d366",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.81 51.92c.24.15.75.15 1.9.15 4.89-.01 9.11-.02 12.11-.02 14.02 0 13.66-14.76 7.1-16.6.96-1.7 5.33-4.9 2.63-11.5-2.68-6.53-14.18-5.05-22.05-5.05-2.91 0-2.47 2.16-2.46 5.5.02 5.3.01 19.64 0 25.84 0 1.25.38 1.45.77 1.68zm6.07-5.41H37c3.03-.01 5.73-1.42 5.66-4.44-.05-2.84-1.94-3.78-4.57-4.04-2.49.03-5.35.03-8.21.03zm0-14.16c5.27-.07 7.3.21 10.18-.51 1.98-1.12 2.84-5.29.01-6.7-1.96-.98-7.78-.65-10.19-.55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWppbusiness);
export default __webpack_public_path__ + "static/media/wppbusiness.18969f385200472e2310f83c03aec1d1.svg";
export { ForwardRef as ReactComponent };